<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <draw-table></draw-table>
      </b-col><!--/.col-->
    </b-row><!--/.row-->
  </div>

</template>

<script>
  import DrawTable from './DrawTable.vue'

  export default {
    name: 'lottery-draw',
    components: {DrawTable}
  }
</script>



// WEBPACK FOOTER //
// src/views/lottery/draw/Draw.vue